<template>
  <div>
    <div class="form__field">
      <div class="form__title">{{ label }}</div>
    </div>
    <div class="form__breaker"></div>
  </div>
</template>

<script>
export default {
  props: {
    label: String
  }
}
</script>
